import { Alert, Box, CircularProgress } from '@mui/material'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import useAxios from '../../../../hooks/useAxios'
import OrderInfoCard from './components/OrderInfoCard'
import OrderLineItemsTable from './components/OrderLineItemsTable'
import SettlementBreakdownTable from './components/SettlementBreakdownTable'
import { ISaleOrderDetail } from './types'
import { groupLineItems, settlementToBucket } from './utils'

const TiktokSaleOrderDetailPage = () => {
  const { orderId } = useParams<{ orderId: string }>()

  const { data, error, isLoading } = useAxios<ISaleOrderDetail>(
    orderId ? { method: 'GET', url: `/tiktok/report/order/${orderId}` } : null,
  )

  const lineItems = useMemo(
    () => groupLineItems(data?.raw, data?.line_items),
    [data],
  )
  const bucket = useMemo(
    () => (data ? settlementToBucket(data) : undefined),
    [data],
  )

  return (
    <ContentWrapper>
      <Helmet title={`คำสั่งซื้อ TikTok #${orderId ?? ''}`} />
      <HeaderContent
        title="รายละเอียดคำสั่งซื้อ TikTok"
        descriptions="ข้อมูลคำสั่งซื้อ รายการสินค้า และรายละเอียดการชำระเงิน"
      />

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      )}

      {error && !isLoading && (
        <Alert severity="error" sx={{ mb: 2 }}>
          ไม่สามารถโหลดรายละเอียดคำสั่งซื้อได้ กรุณาลองใหม่อีกครั้ง
        </Alert>
      )}

      {!isLoading && !error && !data && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          ไม่พบคำสั่งซื้อนี้
        </Alert>
      )}

      {data && (
        <>
          <OrderInfoCard detail={data} />
          <OrderLineItemsTable items={lineItems} />
          {data.settled ? (
            <SettlementBreakdownTable summary={bucket} />
          ) : (
            <Alert severity="info" sx={{ mb: 2 }}>
              ออเดอร์นี้ยังไม่ถึงรอบจ่าย (settlement) —
              ยังไม่มีรายละเอียดการชำระเงิน
            </Alert>
          )}
        </>
      )}
    </ContentWrapper>
  )
}

export default TiktokSaleOrderDetailPage
